import axiosInstance from '../axiosInterceptor/axiosInstance'

const getSeasonTeams = async (orgId, seasonId, groupId, teamId) => {
  const params = new URLSearchParams()

  if (seasonId) {
    params.append('seasonId', seasonId)
  }

  if (groupId) {
    params.append('groupId', groupId)
  }

  if (teamId) {
    params.append('teamId', teamId)
  }

  const url = `v1/orgs/${orgId}/season-teams?${params.toString()}`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getSeasonTeams
